module.exports = __webpack_public_path__ + "img/7@2xa.8c36846d.png";